import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTheme } from "@mui/material/styles";

const Navbar = () => {
  const [navColor, setNavColor] = useState("transparent");
  const [mobileMenu, setMobileMenu] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavColor("#000");
    } else {
      setNavColor("transparent");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  const handleMobileMenuOpen = (event) => {
    setMobileMenu(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenu(null);
  };

  const navLinks = [
    { title: "Home", link: "#home" },
    { title: "About", link: "#about" },
    { title: "Projects", link: "#projects" },
    { title: "Services", link: "#services" },
    { title: "Blog", link: "#blog" },
    { title: "Contact Us", link: "#contact" },
  ];

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: navColor,
        transition: "all 0.4s ease",
        fontFamily: "Helvetica, sans-serif",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: { xs: 2, sm: 4, md: 8 },
          py: 1,
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <a
            href="#home"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <img
              src="/images/interior-aee.png"
              alt="logo"
              style={{
                height: 42,
                marginRight: 8,
              }}
            />

            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#fff",
                letterSpacing: 1,
              }}
            >
              INDESIG
            </Typography>
          </a>
        </Box>

        {/* Desktop Menu */}
        {!isMobile && (
          <Box>
            {navLinks.map((link, index) => (
              <Button
                key={index}
                href={link.link}
                sx={{
                  color: "#fff",
                  mx: 1,
                  fontWeight: 500,
                  textTransform: "none",
                  fontSize: "15px",
                  "&:hover": {
                    color: "#C29D59",
                    backgroundColor: "transparent",
                  },
                }}
              >
                {link.title}
              </Button>
            ))}
          </Box>
        )}

        {/* Desktop Contact Section */}
        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#fff",
              }}
            >
              <PhoneIcon
                sx={{
                  mr: 1,
                  color: "#C29D59",
                }}
              />

              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    opacity: 0.8,
                    display: "block",
                  }}
                >
                  Call Us Phone
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  (+480) 123 678 900
                </Typography>
              </Box>
            </Box>

            <Button
              variant="contained"
              href="#contact"
              sx={{
                background: "#C29D59",
                borderRadius: "50px",
                px: 3,
                py: 1,
                fontWeight: "bold",
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "#b88b4e",
                  boxShadow: "none",
                },
              }}
            >
              Get A Quote
            </Button>
          </Box>
        )}

        {/* Mobile Menu */}
        {isMobile && (
          <>
            <IconButton
              onClick={handleMobileMenuOpen}
              sx={{
                color: "#fff",
              }}
            >
              <MenuIcon />
            </IconButton>

            <Menu
              anchorEl={mobileMenu}
              open={Boolean(mobileMenu)}
              onClose={handleMobileMenuClose}
              PaperProps={{
                sx: {
                  backgroundColor: "#000",
                  color: "#fff",
                  minWidth: 220,
                },
              }}
            >
              {navLinks.map((link, index) => (
                <MenuItem
                  key={index}
                  component="a"
                  href={link.link}
                  onClick={handleMobileMenuClose}
                >
                  {link.title}
                </MenuItem>
              ))}

              <MenuItem>
                <PhoneIcon
                  sx={{
                    mr: 1,
                    color: "#C29D59",
                  }}
                />
                (+480) 123 678 900
              </MenuItem>

              <MenuItem>
                <Button
                  fullWidth
                  variant="contained"
                  href="#contact"
                  onClick={handleMobileMenuClose}
                  sx={{
                    background: "#C29D59",
                    borderRadius: "50px",
                    textTransform: "none",
                    "&:hover": {
                      background: "#b88b4e",
                    },
                  }}
                >
                  Get A Quote
                </Button>
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;